// extracted by mini-css-extract-plugin
export default {"link":"emailButton-module__link__ccbTf","text":"emailButton-module__text__S41IG"};